export default __webpack_public_path__ + "static/media/sundatranslator.dd8f4f84.png";